import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './Button';
import { ErrorMessageProps } from '../../types/components';

export function ErrorMessage({
  title = 'Something went wrong',
  message,
  onRetry,
  retryText = 'Try Again',
  className = ''
}: ErrorMessageProps) {
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <div className="text-center">
        <AlertCircle className="w-8 h-8 text-red-600 mx-auto mb-4" />
        <p className="text-gray-900 font-medium mb-2">{title}</p>
        <p className="text-gray-600 mb-4">{message}</p>
        {onRetry && (
          <Button
            onClick={onRetry}
            variant="primary"
            icon={<RefreshCw className="w-4 h-4" />}
          >
            {retryText}
          </Button>
        )}
      </div>
    </div>
  );
}